<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock v-if="!loading.display" :title="titre">
        <ResumeCandidature
          v-if="candidature.id"
          :candidature="candidature"
          :voirTypeEtudiant="true"
        ></ResumeCandidature>

        <v-row cols="12" justify="center">
          <div class="text-center">
            <ButtonConfirmation
              v-if="
                user.roles.indexOf('ROLE_SCOLARITE') > -1 &&
                candidature.etatDemande.id == ETAT.CONFIRMEE.code
              "
              :inactif="loadingBtn"
              icone="mdi-account-arrow-left"
              libelle="Finaliser"
              title="Finaliser la candidature"
              @ok="finaliserCandidature"
            ></ButtonConfirmation>
            <v-btn class="mx-2" @click="retour">Retour</v-btn>
          </div>
        </v-row>
      </BaseBlock>
    </v-col>
  </v-row>
</template>
<script>
import BaseBlock from "@/components/base/BaseBlock";
import ResumeCandidature from "@/components/ResumeCandidature";
import ApiCandidatureRepository from "@/repositories/ApiCandidatureRepository";
import { mapState } from "vuex";
import { EtatDemande } from "@/mixins/EtatDemande.js";
import ButtonConfirmation from "@/components/ButtonConfirmation";

export default {
  name: "DetailCandidature",
  props: ["idCandidature"],
  components: { BaseBlock, ResumeCandidature, ButtonConfirmation },
  mixins: [EtatDemande],
  data() {
    return {
      candidature: {
        id: "",
        etudiant: {},
        formation: {},
        etatDemande: {},
        bacSerie: "",
      },
      loadingBtn: false,
    };
  },
  methods: {
    async getCandidature() {
      //await new Promise(r => setTimeout(r, 2000));
      try {
        const candidature = await ApiCandidatureRepository.getCandidature(
          this.idCandidature
        );
        this.candidature = candidature;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.$store.commit("setEcranChargement", false);
      }
    },
    retour() {
      this.$router.go(-1);
    },
    async finaliserCandidature() {
      this.loadingBtn = true;
      try {
        const candidatureUpdate =
          await ApiCandidatureRepository.finaliserCandidature(
            this.idCandidature
          );
        this.candidature.etatDemande = candidatureUpdate.etatDemande;
        this.candidature.dateFinalisation = candidatureUpdate.dateFinalisation;
        this.$toast.info(
          "La candidature a été finalisée. Une notification par mail a été adressée à l'étudiant."
        );
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.loadingBtn = false;
        this.retour();
      }
    },
  },
  computed: {
    ...mapState(["loading", "user"]),
    titre() {
      return `Candidature de ${this.candidature.etudiant.nom} ${this.candidature.etudiant.prenom} à la formation ${this.candidature.formation.libelle}`;
    },
  },
  async created() {
    this.$store.commit("setEcranChargement", true);
    this.getCandidature();
  },
};
</script>
